
    // //ao submitar o form
    // $("form:not('.ajax_off')").submit(function (e) {
    //     e.preventDefault();
    //
    //     var form = $(this);
    //
    //     // google recaptcha - se tiver ativo (<form data-verify="recaptcha"...), gera token e submit form
    //     if (form.data().verify === 'recaptcha') {
    //
    //         grecaptcha.ready(function() {
    //             grecaptcha.execute(CONF_GOOGLE_RECAPTHA_V3_SITE, {action: 'submit'}).then(function(token) {
    //                 submitControllForm(form, token);
    //             });
    //         });
    //
    //     } else {
    //         submitControllForm(form);
    //     }
    //
    // });
    //
    // //submit form
    // function submitControllForm(form, token = null) {
    //
    //
    //     var form = $(this);
    //     var load = $(".ajax-load");
    //     var flashClass = "ajax_response";
    //     var flash = $("." + flashClass);
    //
    //     form.ajaxSubmit({
    //         url: form.attr("action"),
    //         type: "POST",
    //         dataType: "json",
    //         data: { token: token },
    //         beforeSend: function () {
    //             load.fadeIn(200);
    //         },
    //         success: function (response) {
    //
    //             //redirect
    //             if (response.redirect) {
    //                 window.location.href = response.redirect;
    //             }
    //
    //             //reload
    //             if (response.reload) {
    //                 window.location.reload();
    //             }
    //
    //             //message
    //             if (response.message) {
    //                 load.fadeOut(200);
    //                 if (flash.length) {
    //                     //flash.html(response.message).fadeIn(100).effect("bounce", 300);
    //                     flash.html(response.message).fadeIn(100);
    //                 } else {
    //                     form.prepend("<div class='" + flashClass + "'>" + response.message + "</div>")
    //                         .find("." + flashClass);
    //                 }
    //             } else {
    //                 flash.fadeOut(100);
    //             }
    //
    //         },
    //         complete: function () {
    //
    //             if (form.data("reset") === true) {
    //                 form.trigger("reset");
    //             }
    //         }
    //     });
    //
    // }




//ajax form
$(function () {

    $("form:not('.ajax_off')").submit(function (e) {
        e.preventDefault();
        var form = $(this);
        var load = $(".ajax-load");
        var flashClass = "ajax_response";
        var flash = $("." + flashClass);

        form.ajaxSubmit({
            url: form.attr("action"),
            type: "POST",
            dataType: "json",
            beforeSend: function () {
                load.fadeIn(200);
            },
            success: function (response) {

                //redirect
                if (response.redirect) {
                    window.location.href = response.redirect;
                }

                //reload
                if (response.reload) {
                    window.location.reload();
                }

                //message
                if (response.message) {
                    load.fadeOut(200);
                    if (flash.length) {
                        //flash.html(response.message).fadeIn(100).effect("bounce", 300);
                        flash.html(response.message).fadeIn(100);
                    } else {
                        form.prepend("<div class='" + flashClass + "'>" + response.message + "</div>")
                            .find("." + flashClass);
                    }
                } else {
                    flash.fadeOut(100);
                }

            },
            complete: function () {

                if (form.data("reset") === true) {
                    form.trigger("reset");
                }
            }
        });
    })
});